import { createRecipe } from './runtime';

const statusDotConfig = {"name":"statusDot"}

export const statusDot = /* @__PURE__ */ createRecipe(statusDotConfig)